import { withChartLayout } from 'components/common';
import SavedIVs from 'components/features/chart/ivs/saved-ivs/SavedIVs';

const SavedIVsPage = withChartLayout('Saved IVs Charting')(SavedIVs);
export default SavedIVsPage;
